import { cn } from '@/lib/utils';
import React from 'react';

export interface SectionHeaderProps {
  title: string;
  titleEditorId?: string;
  description?: string;
  descriptionEditorId?: string;
  action?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  spacing?: 'compact' | 'normal' | 'relaxed';
}

export function SectionHeader({
  title,
  description,
  titleEditorId,
  descriptionEditorId,
  action,
  className,
  titleClassName,
  descriptionClassName,
  spacing = 'normal',
}: SectionHeaderProps) {
  const spacingClasses = {
    compact: 'mb-3',
    normal: 'mb-4',
    relaxed: 'mb-6',
  };

  const descriptionSpacingClasses = {
    compact: 'mt-1',
    normal: 'mt-1.5',
    relaxed: 'mt-2',
  };

  return (
    <div className={cn(spacingClasses[spacing], className)}>
      <div className="flex items-center justify-between">
        <h2 className={cn('text-[var(--text-color)] text-lg font-semibold', titleClassName)} editor-id={titleEditorId}>
          {title}
        </h2>
        {action && <div className="text-[var(--text-secondary-color)] text-sm">{action}</div>}
      </div>
      {description && (
        <p
          className={cn(
            'text-[var(--text-secondary-color)] text-sm leading-relaxed',
            descriptionSpacingClasses[spacing],
            descriptionClassName,
          )}
          editor-id={descriptionEditorId}
        >
          {description}
        </p>
      )}
    </div>
  );
}
